import { useRef, useState } from "react";
import { Box, Modal, Slider, Button, Grid } from "@mui/material";
import AvatarEditor from "react-avatar-editor"
import CommonButton from "components/commonButton/CommonButton";

const boxStyle = {
  width: "300px",
  height: "300px",
  display: "flex",
  flexFlow: "column",
  justifyContent: "center",
  alignItems: "center"
};
const modalStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};

// Modal
const CommonCropImage = ({ src, modalOpen, setModalOpen, handleCropSave ,handleCloseModal}) => {
  const [slideValue, setSlideValue] = useState(10);
  const cropRef = useRef(null);

  //handle save
  const handleSave = async () => {
    if (cropRef) {
      const dataUrl = cropRef.current.getImage().toDataURL();
      const result = await fetch(dataUrl);
      const blob = await result.blob();
      setModalOpen(false);
      handleCropSave(blob)
    }
  };

  return (
    <Modal sx={modalStyle} open={modalOpen}>
      <Box sx={boxStyle}>
        <AvatarEditor
          ref={cropRef}
          image={src}
          className="avatarEdit"
          border={50}
          borderRadius={150}
          color={[0, 0, 0, 0.72]}
          scale={slideValue / 10}
          rotate={0}
        />

        {/* MUI Slider */}
        <Slider
          min={10}
          max={50}
          className="sliderAlign"
          size="medium"
          defaultValue={slideValue}
          value={slideValue}
          onChange={(e) => setSlideValue(e.target.value)}
        />
        <Grid container className='justifyArround'
        >
          <CommonButton
            btnClass="btnCropOutline btnSm"
            variant="outlined"
            onClick={handleCloseModal}
            name={'Cancel'}
          />
          <CommonButton
            btnClass="btnCancel btnSm"
            variant="contained"
            onClick={handleSave}
            name={'Save'}
          />
        </Grid>
      </Box>
    </Modal>
  );
};
export default CommonCropImage;

